import { useTheme } from "@emotion/react";
import { Message } from "@fullscript/aviary-web";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./PreviewModeBanner.styles";

const PreviewModeBanner = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <div css={styles.wrapper(theme)}>
      <Message
        intention="warning"
        title={t(l.patientRxAuth.storeLandingPages.previewBanner.title)}
        label={t(l.patientRxAuth.storeLandingPages.previewBanner.text)}
      />
    </div>
  );
};

export { PreviewModeBanner };
